














import MainButton from '@/main-components/common/MainButton.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: { MainButton },
})
export default class QuestionBankNeedMore extends Vue {
  @Prop({ required: true })
  onPremiumClicked: () => void;

  @Prop({ required: true })
  questionCount: number | null;

  onMoreClicked() {
    this.onPremiumClicked && this.onPremiumClicked();
  }
}
